import React, {Fragment} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {useModelUpdateEngine} from "../common/hooks/useModelUpdateEngine";
import {InvoicePaymentSettingsForm} from "./InvoicePaymentSettingsForm";

export const UpdateInvoicePaymentSettings = function (props) {
    const modelUpdateEngine = useModelUpdateEngine(
        ApiUtility.getInvoicePaymentSettings,
        ApiUtility.updateInvoicePaymentSettings,
        null,
        'invoice payment settings',
        () => {
            modelUpdateEngine.renderableData.updateAndRender({loading: false})
        }
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelUpdateEngine.renderableData.loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ConditionalRenderer if={modelUpdateEngine.renderableData.model} renderer={() => (
                <InvoicePaymentSettingsForm
                    cancel={props.cancel}
                    save={modelUpdateEngine.updateModel}
                    invoicePaymentSettings={modelUpdateEngine.renderableData.model}
                />
            )}/>
        </Fragment>
    );
}
